import { snakeCase } from 'change-case';

import { transformObjectKeys } from '../../../../../utils/general';

export const transformRequestBody = (data: unknown): unknown => {
  if (data instanceof FormData || data instanceof Blob) {
    return data;
  }
  if (data && typeof data === 'object') {
    return transformObjectKeys(data as Record<string, unknown>, (key) =>
      snakeCase(key, { stripRegexp: /[^A-Z0-9.]/gi }),
    );
  }
  return data;
};
